import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/V1/Employee'

const EmployeeInfo = {
  PageData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PageData`,
      data

    })
  },
  Import(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Import`,
      data
    })
  },
  Create(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Create`,
      data
    })
  },
  Detail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}`,
      params
    })
  },
  Modify(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Modify`,
      data
    })
  },
  Delete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Delete`,
      data
    })
  }
}

export default EmployeeInfo
